import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Category } from 'src/app/model/category';
import { HomeConfig } from 'src/app/model/homeConfig';
import { environment } from 'src/environments/environment';
import { AppModeService } from '../../../services/app-mode.service';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private readonly apiUrl: string = '/api/';
  private readonly mobileApiUrl: string = '/api/mobile/';
  private readonly mainUrl: string = environment.apiUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly appModeService: AppModeService,
  ) {}

  /**
   * Get the appropriate API endpoint based on app/desktop mode
   */
  private getApiUrl(): string {
    return this.appModeService.isApp() ? this.mobileApiUrl : this.apiUrl;
  }

  /**
   * Get all categories
   * Calls /api/categories for web or /api/mobile/categories for app
   */
  getCategories(): Observable<Category[]> {
    const apiUrl = this.getApiUrl();
    return this.http.get<Category[]>(this.mainUrl + apiUrl + 'categories');
  }

  /**
   * Get category by name
   * Calls /api/category-by-name/:name for web or /api/mobile/category-by-name/:name for app
   */
  getCategoryByName(name: string): Observable<Category> {
    return this.http.get<Category>(
      this.mainUrl + this.apiUrl + 'category-by-name/' + name,
    );
  }

  /**
   * Get home configuration
   * Note: This endpoint may be shared between app and web, adjust if needed
   */
  getConfig(lang: string): Observable<HomeConfig> {
    return this.http.get<HomeConfig>(
      `${this.mainUrl}/dashboard/home-config/main/${lang}`,
    );
  }
}
